<!-- Toast global estándar -->
<p-toast position="bottom-left"></p-toast>

<!-- Toast personalizado con barra de progreso (Fix 2: persiste al navegar) -->
<p-toast position="bottom-left" key="corpaceros-sync-progress">
    <ng-template let-message pTemplate="message">
        <div class="flex flex-column" style="flex: 1">
            <div class="text-center">
                <i class="pi pi-sync" style="font-size: 2rem"></i>
                <h4>{{message.summary}}</h4>
            </div>
            <p class="m-0">{{corpacerosSyncService.syncDetail}}</p>
            <p-progressBar [value]="corpacerosSyncService.syncProgress" [showValue]="false" styleClass="mt-2"></p-progressBar>
        </div>
    </ng-template>
</p-toast>

<router-outlet *ngIf="!isIframe"></router-outlet>

<app-pwa-install-prompt></app-pwa-install-prompt>
